import { IconButton } from '@/trailmix/IconButton';
import { cn } from '@/trailmix/lib/cn';
import { Input, InputGroup, InputLeftElement } from '@chakra-ui/react';
import { mdiClose, mdiMagnify } from '@mdi/js';
import Icon from '@mdi/react';
import { useRef, useState } from 'react';
import { useFilterQueryParam } from '@/filters/useFilterQueryParam';

/**
 * Renders a search bar that's used to quickly filter a list of records by place name.
 *
 * @see `useFilterQueryParam`
 */
export function PlaceNameFilterControl({ className }: { className?: string }) {
    const {
        value: placeNameFilterValue,
        isModified,
        onReset,
        onChange,
    } = useFilterQueryParam({ filterId: 'name', defaultValue: '' });

    const [name, setName] = useState(placeNameFilterValue);
    const initialFocusRef = useRef(null);

    return (
        <form
            onSubmit={e => {
                e.preventDefault();
                onChange(name);
            }}
            className={cn('flex items-center gap-1', className)}
        >
            <InputGroup className=''>
                <InputLeftElement pointerEvents='none' color='gray.500'>
                    <Icon path={mdiMagnify} className='size-5' />
                </InputLeftElement>
                <Input
                    ref={initialFocusRef}
                    value={name}
                    onChange={e => setName(e.target.value)}
                    type='search'
                    variant=''
                    placeholder='Search for a place'
                    bgColor='white'
                    borderColor='gray.300'
                    _hover={{ borderColor: 'gray.400' }}
                    _placeholder={{ color: 'gray.500' }}
                />
            </InputGroup>

            {isModified && (
                <IconButton
                    onClick={onReset}
                    icon={<Icon path={mdiClose} className='size-5 text-gray-600' />}
                    variant='ghost'
                    aria-label='Reset'
                />
            )}
        </form>
    );
}
